<div *ngIf="request$| async as detailData">
    <div class="text-2xl font-semibold ">Lista formalità - {{detailData._description}} <br><span
            class="text-xs text-secondary"> PDF disponibile
            nell'<a [routerLink]="['/', 'user','consolle-immobiliare','documents']"
                class="hover:text-primary transition-colors">Archivio Documenti</a></span></div>
    <app-navigazione-results [items]="detailData.queryResult?.items || []" [navigation]="navigation"
        [listLayout]="listLayout">
    </app-navigazione-results>
</div>